<template>
  <div class="mobile-wrap" ref="homePage">
    <!-- <div id="app"> -->
    <div v-if="platform === 'mobile'">
      <div class="pic">
        <img v-if="!info.brand" src="../img/eilis.png" style="transform: scale(1); margin-left: 10px;" alt="louisa logo"  width="100%">
        <img v-if="info.brand === 'NAUTICA'" src="../img/Nautica.png" style="transform: scale(0.7); margin-top: -120px;" alt="louisa logo"  width="100%">
        <img v-if="info.brand === 'Whittard'" src="../img/whittard.jpg" style="transform: scale(0.5); margin-top: -110px; z-index: 1"   width="100%">
        <img v-if="info.brand === 'Eden Park'" src="../img/Eden-Park.png" style="transform: scale(1); position:fixed; margin-top: 0px; left: 0%; z-index: 1"   width="100%">
        <img v-if="info.brand === 'JEEP'" src="../img/JEEP.png" style="transform: scale(1); position:fixed; margin-top: 15px; left: 0%; z-index: 1" width="100%">
        <img v-if="info.brand === 'LIP SERVICE'" src="../img/LIP.jpg" style="transform: scale(0.6); position:fixed; margin-top: -90px; left: 0%; z-index: 1" width="100%">
        <!-- <section>
          <svg id="curve" data-name="圖層 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 616.67 440">
          <path class="cls-1" d="M604.78-8.44s-22.1,58-110.48,70.91c-71.58,10.44-333,22-371.61,191.8C84.53,421.89-11.89,431.56-11.89,431.56v-440Z" transform="translate(11.89 8.44)"/></svg>
        </section> -->
      </div>
      <br>
       <!-- AuthToken -->
      <!-- <cube-textarea class="item" :placeholder="transform" disabled style="">
      </cube-textarea> -->
        <!-- 選擇國碼 -->
        <cube-select class="item" icon="perm_identity" @change="change" v-model="countryCode" confirmTxt="確認" title="請選擇" placeholder="選擇國碼" :options="countries" :disabled="phoneVerify">
          <!-- <mu-option v-for="(code, index) in countries" :key="index" :label="$t(code.text)" :value="code.value"></mu-option> -->
        </cube-select>
        <!-- 輸入電話 -->
        <!-- <cube-input   class="item"  v-model="phoneNumber"  :placeholder="$t('Login.authHint') + countries.filter(el => el.value === countryCode).map(el => el.example)[0]" :disabled="phoneVerify">
        </cube-input> -->
        <cube-input    class="item"  :style="{background: info.brand === 'Eden Park' ? '#fad4fa' : '', color: info.brand === 'Eden Park' ? '#020012' : '', 'font-size': '20px', 'font-weight': 'bold',}" :maxlength="10" v-model="phoneNumber"  :placeholder="place(countryCode)" :disabled="phoneVerify">
        </cube-input>
        <!-- <div class="recaptcha-container" id="recaptcha-container"></div> -->
        <!-- 認證按鈕 -->
        <cube-button  :style="{background: info.brand === 'Eden Park' ? '#00174d' : '', color: info.brand === 'Eden Park' ? 'white' : '', 'font-size': '20px', 'font-weight': 'bold', 'transform': 'translateY(0px)'}" class="item"  @click="checkingPhone"  :disabled="phoneNumber === '' || number !== ''">{{ $t('Login.verify') }} {{number}}</cube-button>
        <!-- <cube-textarea style="top: -15px;" class="item" icon="account_circle" label-float  label="請輸入真實姓名" v-model="name" v-if="phoneVerify">
        </cube-textarea> -->
        <!-- 輸入驗證碼 -->
        <cube-input  :style="{'font-size': '20px'}"  class="item" placeholder="請輸入驗證碼" v-model="verCode" v-if="phoneVerify" ></cube-input>
        <cube-button id="sign-in-button"  class="item" v-if="phoneVerify" size="medium" style="transform: translateY(0px); font-size: 20px;" @click="codeVer" >{{ $t('Login.verify') }}</cube-button>

        <cube-button class="item" style="width: 10%; margin-right: 20px; border:none; transform: scale(0.8);" :light="true" v-if="phoneVerify" @click="showHint()">收不到驗證碼嗎？</cube-button>
        <!-- <cube-select  v-model="value" icon="home" :placeholder="option[0]" @change=chosen class="btn2" style="font-size:17px; width:90%; left:18px;" v-if="phoneVerify">
          <mu-option
            v-for="(item,index) in option"
            :key="index"
            :label="item"
            :value="item">
          </mu-option>
        </cube-select>
        <cube-select  v-model="value0" class="btn2" v-if="phoneVerify" :options="(item,index) in options[value]">
          <mu-option
            :options="(item,index) in options[value]"
            :key="index"
            :label="item"
            :value="item">
          </mu-option>
        </cube-select> -->
        <!-- <cube-textarea style="top: -15px;" class="item" icon="home" label-float  label="請輸入常用外送地址" v-model="address" v-if="phoneVerify">
        </cube-textarea> -->
      <br><br>
      <div class="bottom">
        <!-- <img src="../img/eilis.png" alt="Smiley face" height="14" width="">
        <div style="transform: scale(0.7)"> 智慧互動助理提供</div> -->
      </div>
      <cube-loading :size="35" class="loadingIcon" v-if="loading"></cube-loading>
      <div id="layer" v-if="loading"/>
    </div>
    <!-- QR Code -->
    <div v-if="platform === 'desktop'">
      <div style="border: 1px solid #cbced3; display: inline-block; padding: 20px; padding-bottom: 12px; margin-top: 40px; width: 200px;">
        <qrcode-vue :value="qrcode" size="150" level="H"></qrcode-vue>
      </div>
      <div style="margin-top: 15px;">
        {{ $t('Login.no_service') }}<br>{{ $t('Login.scan_code') }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapMutations, mapGetters, mapActions } from 'vuex'
import axios from 'axios';

const CryptoJS = require('crypto-js');
export default {
  data () {
    return {
      availHeight: '',
      // brand: this.$route.query.brand ? this.$route.query.brand : localStorage.getItem('brand'),
      crossPlatform: false,
      userId: '',
      phone: '',
      //
      accessToken: '',
      number: '',
      tempCode: '198911',
      phoneVerify: false,
      loading: false,
      value: '',
      address: '',
      platform: '',
      yourdrink: this.$route.query.drink,
      verifyId: '',
      verCode: '',
      AuthToken: this.$route.params.Auth_u,
      Service: this.$route.params.service,
      visibility: false,
      alert: false,
      alertmessage: '電話號碼還未輸入喔！',
      countryCode: '886',
      noVerify: this.$route.query.noVer ? this.$route.query.noVer : false,
      channelData: {
        AuthToken: this.$route.query.Auth,
        Service: this.$route.params.service,
        // PhoneNumber: '',
        Name: this.$route.query.Name ? this.$route.query.Name : '',
        PageID: this.$route.query.Page,
        trigger: this.$route.query.trigger,
        Img: this.$route.query.Img,
        transactionId: this.$route.query.transactionId,
      },
      countries:[
        {
          text: '台灣(+886)',
          value: '886',
          example: '0912345678'
        },
        // {
        //   text: '柬埔寨(+855)' ,
        //   value: '855',
        //   example: '091234567'
        // },
        // {
        //   text: '馬來西亞(+60)',
        //   value: '60',
        //   example: '0123456789'
        // }
      ],
    }
  },
  mounted() {
    // console.log(this.brandCode);
    // this.phoneVerify = true;
    // console.log(this.info.clientId);
    this.platform = 'mobile';
    // console.log(localStorage.getItem('brand'));
    this.availHeight = `${window.screen.availHeight}`;
    this.$refs.homePage.style.height = this.availHeight+ 'px';
    // console.log(this.availHeight+ 'px');
  },
  watch: {
    // 監聽驗證碼輸入為6碼
    verCode(newV) {
      if (newV.length > 6) {
        newV = newV.slice(0, 6)
        this.$nextTick(() => {
          this.verCode = newV
        })
      }
    },
    phoneNumber(val) {
      const re = /^[0-9]+$/;
      if (!re.test(val)) {
        this.Alert();
        this.$nextTick(() => {
          this.phoneNumber = '';
        })
      }
    },
  },
  computed: {
    ...mapGetters({
      info: 'info',
      brandCode: 'brandCode',
      tempInfo: 'tempInfo',
      ruentexProfile: 'ruentexProfile'
    }),
    transform() {
      // watch 無法監聽物件, computed不能修改component的值, 所以顯示會用placeholder
      if (this.channelData.Service === 'LINE') {
        return this.channelData.AuthToken.substr(5,10);
      } else {
        return this.channelData.AuthToken
      }
    },
    // equal() {
    //   // console.log(this.brand);
    //   if (this.info.brand === 'NAUTICA') {
    //     return 'NS';
    //   } else if (this.brand === 'JEEP') {
    //     return 'JP';
    //   } else if (this.brand === 'Eden Park') {
    //     return 'EP';
    //   } else if (this.brand === 'Lulu Guinness') {
    //     return 'LU';
    //   } else if (this.brand === 'Whittard') {
    //     return 'WH';
    //   } else if (this.brand === 'LIP SERVICE') {
    //     return 'LP';
    //   }
    // },
    ruFile: {
      get () { return this.ruentexProfile },
      set(value) { this.storeRuenFile({ Profile: value }); },
    },
    token: {
      get () { return this.info.token },
      set(value) { this.updatetoken({ token: value }); },
    },
    phoneNumber: {
      get () { return this.info.phone },
      set(value) { this.updatephone({ phone: value }); },
    },
    name: {
      get () { return this.info.name },
      set(value) { this.updatename({ name: value }); },
    },
    birth: {
      get () { return this.info.birth },
      set(value) { this.updatebirth({ birth: value }); },
    },
    tInfo: {
      get () { return this.tempInfo },
      set(value) { this.storeTempInfo({ tempInfo: value }); },
    },

  },
  methods: {
    ...mapMutations({
      updatephone: 'updatephone',
      updatetoken: 'updatetoken',
      updatename: 'updatename',
      updatebirth: 'updatebirth',
      storeTempInfo: 'storeTempInfo',
      storeRuenFile: 'storeRuenFile'
    }),
    ...mapActions({
      ChTextMsg: 'ChTextMsg',
      checkMember: 'checkMember',
      checkUserByToken: 'checkUserByToken',
      checkPhoneNumbers: 'checkPhoneNumbers',
      readMember: 'readMember',
      updateMember: 'updateMember',
      registerEilis: 'registerEilis',
      fastClearance: 'fastClearance',
      updateMemberEilis: 'updateMemberEilis'
    }),
    showHint() {
      this.$createDialog({
        type: 'alert',
        title: '提示',
        confirmBtn: '確定',
        content: `怎麼辦！收不到驗證碼 <br/> 1. 請確認目前手機訊號強度，簡訊傳送當下，若所在位置訊號不佳可能造成傳送失敗。
                                    <br/> 2. 請聯繫您的電信業者，關閉「阻擋企業廣告簡訊」之服務，重新開機後再嘗試驗證動作。
                                    <br/> 3. 請確認是否安裝廣告阻擋或網路安全等APP，驗證簡訊可能因此遭阻擋，例：Whoscall。
                                    <br/> 4. 手機的簡訊容量是否已達上限：因各手機型號設定限制不同，若近期未收到任何簡訊訊息，可能已達容量上限，請刪除部分訊息後重新再試。
                                    <br/> 小提醒：
                                    <br/> 若短時間內重覆操作多次驗證動作，建議您請稍待一段時間後再試，避免系統判定連續發送異常唷！`,
        icon: 'cubeic-alert'
      }).show()
    },
    // 解密
    Decrypt(word) {
      // console.log(word);
      var key = "FFzqekWVwgu7Oz28pfyPUlbOk4UusnNc"
      var iv = "2uY28N7v5kVEuFPr"
      const keysStr = CryptoJS.enc.Utf8.parse(key);
      const ivStr = CryptoJS.enc.Utf8.parse(iv);
      let encryptedHexStr = CryptoJS.enc.Base64.parse(word);
      let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
      let decrypt = CryptoJS.AES.decrypt(srcs, keysStr, {
          iv: ivStr,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
      });
      let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
      // console.log(decryptedStr);
      return decryptedStr.toString();
    },
    place(val) {
      const word = '範例: ';
      if (val !== '') {
        return word + this.countries.filter(el => el.value === this.countryCode).map(el => el.example)[0]
      } else {
        return word + this.countries.filter(el => el.value === '+886').map(el => el.example)[0]
      }
    },
    a() {
      this.number -= 1;
    },
    b() {
      this.number = 300;
      var si = setInterval(this.a, 1000);
      setTimeout(() => {
        this.number = '';
        // this.phoneVerify = true;
        clearInterval(si);
      }, 300000);
    },
    checkUser () {
      this.loading = true;
      this.checkUserByToken({service: this.$route.params.service,token: this.channelData.AuthToken, clientId: this.info.clientId, })
      .then((res) => {
        // console.log(res);
        // this.platform = 'mobile';
        // console.log(Object.values(res.data));
        if (res.data.result === '查無此會員') {
          this.loading = false;
        } else if (res.data.detail) {
          setTimeout(() => {
            // this.$router.push(`{ name: 'menu', params: { service: this.$route.params.service }}?Auth=${this.channelData.AuthToken}&Page=${this.channelData.PageID}&trigger=${this.channelData.trigger}`)
            this.$router.push(`/mainbottom/${this.$route.params.service}?Auth=${this.channelData.AuthToken}&Page=${this.channelData.PageID}&trigger=${this.channelData.trigger}`)
            this.loading = false;
          },1000)
        } else if (res.data.Message === '查無此用戶') {
          this.loading = false;
        }
      });
    },
    Alert(val) {
      this.$createDialog({
        type: 'alert',
        title: '小提示',
        content: '格式有誤，請參考範例。',
        icon: 'cubeic-alert',
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
      }).show()
    },
    showAlert(val) {
      this.$createDialog({
        type: 'alert',
        title: '小提示',
        content: val,
        icon: 'cubeic-alert',
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        // onConfirm: (e, promptValue) => {
        //   this.phoneAuth();
        // }
      }).show()
    },
    showAlert1() {
      this.$createDialog({
        type: 'alert',
        title: '小提示',
        content: '驗證碼已發送到手機',
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        // icon: 'cubeic-alert'
      }).show()
    },
    showAlert2(val) {
      this.$createDialog({
      type: 'alert',
      title: '小提示',
      content: val,
      confirmBtn: {
        text: '確定',
        active: true,
        disabled: false,
        href: 'javascript:;'
      },
      // icon: 'cubeic-alert'
      }).show()

    },
    showAlert3() {
      this.$createDialog({
        type: 'alert',
        title: '小提示',
        content: '發生錯誤，系統將自動導回電話驗證頁面。',
        icon: 'cubeic-alert',
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
      }).show()
    },
    checkingPhone() {
      // console.log(this.phoneNumber.length);
      if (this.phoneNumber.length !== 10) {
        const msg = '您輸入的號碼未滿10碼，您可檢查開頭是否為09'
        return this.showAlert(msg)
      }
      // this.phoneAuth()
      this.loading = true;
      this.checkPhoneNumbers({ phone: this.phoneNumber, clientId: this.info.clientId , })
      .then((res)=> {
        // console.log(res);
        // return;
        // return;
        // console.log(Object.entries(res.data.result.service)[0][0]);
        // this.loading = false;
        // return;
        if (res.data.result.phone && Object.entries(res.data.result.service)[0][0] !== this.$route.params.service) {
          this.phone = res.data.result.phone
          this.userId = res.data.result.userId
          this.loading = false;
          this.crossPlatform = true;
          this.phoneAuth();
        }
        else if (res.data.result.phone && Object.entries(res.data.result.service)[0][0] === this.$route.params.service) {
          const content = '此電話已註冊'
          this.loading = false;
          // this.phoneNumber = '';
          this.showAlert(content)
          //
          const url = 'https://script.google.com/macros/s/AKfycbxTrRxfdE3ZqhCVx3E6l2m0S7Zi-KHKgTHGiREY3vNy2KvNVQA/exec';
          const time = new Date(Date.now()).toLocaleString();
          // console.log(time);
          let name = res.data.result.name;
          let phone = this.phoneNumber;
          let birth = res.data.result.birth;
          let Id = this.channelData.AuthToken;
          let oldId = Object.entries(res.data.result.service).filter(el => el[0] === this.$route.params.service)[0][1].id
          // console.log(oldId);
          const data = {
            time,
            name,
            phone,
            birth,
            Id,
            oldId,
          }
          // console.log(data);
          axios.get(url, {params: data})
          .then((res) => {
            // console.log(res);
          })
          return;
        }
        else if (res.data.result.phone && Object.entries(res.data.result.service).length > 1) {
          // const content = '請確認是否已在 Messenger/LINE 註冊。'
          const content = '此電話已註冊'
          this.loading = false;
          // this.phoneNumber = '';
          this.showAlert(content)
          //
          const url = 'https://script.google.com/macros/s/AKfycbxTrRxfdE3ZqhCVx3E6l2m0S7Zi-KHKgTHGiREY3vNy2KvNVQA/exec';
          const time = new Date(Date.now()).toLocaleString();
          // console.log(time);
          let name = res.data.result.name;
          let phone = this.phoneNumber;
          let birth = res.data.result.birth;
          let Id = this.channelData.AuthToken;
          let oldId = Object.entries(res.data.result.service).filter(el => el[0] === this.$route.params.service)[0][1].id
          // console.log(oldId);
          const data = {
            time,
            name,
            phone,
            birth,
            Id,
            oldId,
          }
          // console.log(data);
          axios.get(url, {params: data})
          .then((res) => {
            // console.log(res);
          })
          return;
        }
        else if (res.data.result  === "查無此會員" ) {
          this.loading = false;
          this.phoneAuth();
        }
      });
    },
    phoneAuth() {
      this.loading = true;
      const sixcodes = `${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}`;
      this.tempCode = sixcodes;
      // console.log(this.tempCode);
      // service:FB OR LINE ,gate: channel ID or FB ID
      const word = `成功登錄後，歡迎您升等為${this.info.brand === 'JEEP' ? 'JEEP SPIRIT' : this.info.brand} Taiwan的數位會員`
      const words = `感謝您的申請，您的驗證碼為:`;
      // const words = `使用${this.brand}的驗證碼:`
      // console.log(word);
      // return;
      this.ChTextMsg({ phone: this.phoneNumber, msg: words + sixcodes + word, brand: this.brandCode,})
      .then((res)=> {
        // console.log(res);
        if (res.data.text !== 'mobile tag error') {
          this.b();
          this.phoneVerify = true;
          this.loading = false;
        } else {
          this.showAlert2(res.data.text);
          this.loading = false;
          // window.location.reload();
        }
      });
    },
    codeVer() {
      this.loading = true;
      if (this.verCode === this.tempCode) {
        if (this.crossPlatform === true) {
          // alert("不錯喔 快速通關")
          // return;
          this.fastClearance({service: this.channelData.Service ,clientId: this.info.clientId,token: this.channelData.AuthToken ,userId: this.userId,})
          .then((res) => {
            if (res.data.status === '10020') {
              this.updateMember({
                brand: this.brandCode,
                custid: this.info.clientId,
                phone: this.phone,
                lineid: this.channelData.Service === 'LINE' ? this.channelData.AuthToken : null,
                fbid: this.channelData.Service === 'FB' ? this.channelData.AuthToken : null
              })
              .then(() => {
                this.$router.push(`/mainbottom/${this.$route.params.service}?Auth=${this.channelData.AuthToken}&Page=${this.channelData.PageID}`);
              })
            }
          })
        } else {
          // 是否曾加入Whittard Taiwan會員（非官方網站會員）？ 在店櫃現場可查詢會員編號者，請選擇”是”，反之則否。
        this.loading = false;
        this.$createDialog({
          type: 'confirm',
          showClose: true,
          title: '系統提示',
          content: `是否曾加入${this.info.brand === 'JEEP' ? 'JEEP®SPIRIT' : this.info.brand + '&nbsp;' + 'Taiwan'} 會員 ？ 在店櫃現場可查詢會員編號者，請選擇”是”，反之則否。`,
          confirmBtn: {
            text: '是',
            active: true,
            disabled: false,
          },
          cancelBtn: {
            text: '否',
            active: true,
            disabled: false,
          },
          onCancel: () => {
            //
            this.$router.push(`/register/${this.$route.params.service}?Auth=${this.$route.query.Auth}&Img=${this.channelData.Img}&brand=${this.$route.query.brand}`)
          },
          onConfirm: (e, promptValue) => {
            this.dialog = this.$createDialog({
              type: 'prompt',
              title: '請輸入會員ID',
              prompt: {
                value: '',
                placeholder: ''
              },
              prompt: {
                value2: '',
                placeholder: ''
              },
              confirmBtn: {
                text: '確定',
                active: true,
                disabled: false,
                href: 'javascript:;'
              },
              cancelBtn: {
                text: '上一頁',
                active: true,
                disabled: false,
                href: 'javascript:;'
              },
              onCancel: () => {
                this.codeVer()
              },
              onConfirm: (e, promptValue) => {
                // console.log(promptValue);
                if (!promptValue) {
                  return;
                }
                const ID = promptValue.toUpperCase()
                promptValue = '';
                this.loading = true;
                const phoneNum = promptValue;
                // console.log(ID);
                // console.log(this.info.phone);
                // return;
                this.readMember({ phone: this.info.phone , clientId: ID , brand: this.brandCode,})
                .then((res) => {
                  // console.log(res);
                  const custid = res.data.result.custid
                  const name = res.data.result.name
                  const birth = res.data.result.birth
                  const memberClass = res.data.result.cardkind;
                  const saleroom = res.data.result.saleroom
                  const gender = res.data.result.gender
                  const address = res.data.result.address
                  const email = res.data.result.email
                  const zip = res.data.result.zip
                  this.tInfo.address = address
                  this.tInfo.email = email
                  this.tInfo.birth = birth
                  // return;
                  // 無資料
                  if (res.data.status !== 200) {
                    this.codeVer()
                    this.loading = false;
                  }
                  // else if (res.data.status === 300) {
                  //   // 多筆資料
                  //   const url = 'https://script.google.com/macros/s/AKfycbxTrRxfdE3ZqhCVx3E6l2m0S7Zi-KHKgTHGiREY3vNy2KvNVQA/exec';
                  //   let name = Array.isArray(res.data.result) === true ? res.data.result[0].name : res.data.result.name;
                  //   let phone = this.info.phone;
                  //   let birth = Array.isArray(res.data.result) === true ? res.data.result[0].birth : res.data.result.birth;
                  //   let lineId = this.channelData.AuthToken;
                  //   const data = {
                  //     name,
                  //     phone,
                  //     birth,
                  //     lineId
                  //   }
                  //   axios.get(url, {params: data})
                  //   .then((res) => {
                  //     console.log(res);
                  //   })
                  // }
                  else {
                    // 有一筆資料
                    // this.loading = false;
                    this.updateMember({phone: this.info.phone , custid: ID , brand: this.brandCode, lineid: this.channelData.Service === 'LINE' ? this.channelData.AuthToken : null, fbid: this.channelData.Service === 'LINE' ? null : this.channelData.AuthToken})
                    .then((res) => {
                      // console.log(res);
                      if (res.data.status === 200) {
                        // this.ruFile = res.data.result
                        this.registerEilis({
                          service: this.channelData.Service,
                          clientId: this.info.clientId,
                          token: this.channelData.AuthToken,
                          phone:  this.info.phone,
                          userId: custid,
                          name: name,
                          birth: birth,
                          profileImg: this.channelData.Img ? this.channelData.Img : '',
                        })
                        .then((res) => {
                          if (res.data.status === '10020') {
                            const cardkind = {
                              cardkind: memberClass,
                              saleroom: saleroom
                            }
                            this.updateMemberEilis({clientId: this.info.clientId, phone: this.info.phone, zip: zip, detail: cardkind, address: address, gender: gender, email: email,})
                            .then((res) => {
                              // console.log(res);
                              this.$router.push(`/mainbottom/${this.$route.params.service}?Auth=${this.channelData.AuthToken}&brand=${this.$route.query.brand}`);
                            })
                          } else {
                            this.codeVer()
                          }
                        })
                      } else {
                        this.$createDialog({
                          type: 'alert',
                          icon: 'cubeic-alert',
                          showClose: true,
                          title: '請重新操作',
                          onClose: () => {
                            window.location.reload();
                          }
                        }).show()
                      }
                    })
                  }
                })
              }
            }).show()
          }
        }).show()
        return;
        }
      } else {
        const contents = '驗證碼輸入錯誤，如有重複點選驗證，請留意最新驗證碼訊息'
        this.showAlert2(contents);
        this.loading = false;
      }
    },
    change(value, index, text) {
      // console.log(value)
    },
    chosen (val) {
      // console.log(val);
      this.value0 = this.options[val][0];
      // console.log(this.value0);
    },
  }
}
</script>

<style lang="scss" scoped>
  .recaptcha-container{
    opacity: 0%;
  }
  .mobile-wrap {
    margin: auto;
    width: 300px;
    height: 750px;
    width: 100%;
    overflow: hidden;
    position: relative;
  }
  .mobile-wrap:before {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    content: '';
    position: absolute;
    // background: rgba(90, 93, 165, .8);
    // background: linear-gradient(to bottom, rgba(90, 93, 165, 1), rgba(0, 0, 0, .7))
  }
  .loadingIcon {
    z-index: 100000;
    display: flex; // 置中
    align-items: center; // 置中
    justify-content: center; // 置中
    margin: 0 auto;
    position: fixed;
    top: 50%;
    left: 0;
    right: 0;
    // margin-top: -270px;
    width: 55px;
    height: 55px;
    color: #ffffff;
    border-radius: 5px;
    background-color: #717171;
    -webkit-text-fill-color: transparent;
  }
  #layer{
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(159, 159, 159, 0.527);
  }
  .menu {
    padding-left: 0!important;
    padding-right: 0!important;
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    max-width: 540px;
    min-width: 300px;
    height: 750px;
    background-color: #ffffff;
    /* border: 1px solid rgb(170, 170, 170); */
    /* border:1px solid #8a8a8a; */
  }
  .pic {
    position: relative;
    z-index: 1;
    transform: scale(0.7);
    top: 30px;
    margin: 0px;
    margin-left: 0px;
    height: 150px;
  }
  .item {
    // top: 40px;
    // z-index: 1;
    // border-radius: 10px;
    width: 80%;
    max-width: 420px;
    min-width: 200px;
    margin: 0 auto;
    margin-top: 30px;
  }
  section {
    position: relative;
    background-color: none;
    width: 100%;
    height: 100vh;
  }
  #curve {
    z-index: 1000;
    position: relative;
    transform: scale(4) rotate(6deg);
    bottom: 500px;
    left: 200px;
    width: 100%;
  }
  #curve path {
    fill: rgb(76, 182, 14);
  }
  .bottom {
    font-size: 5px;
    position: relative;
    margin-top: 160px;
  }
</style>
